import React, { useState, useEffect } from 'react'

import Modal from 'Components/Modal'
import TicketCreateForm from 'Components/Tickets/Form'

const TicketCreateModal = (props) => {
  const [displayModal, setDisplayModal] = useState(false)
  const [formProps, setFormProps] = useState(null)

  useEffect(() => {
    fetch('/tickets/new.json')
      .then(response => response.json())
      .then(data => setFormProps(data))
  }, [])

  if (!formProps) return null

  const { clients, current_user: currentUser } = formProps
  const isClientMigratedToHalo = !currentUser?.calligo_employee
    && clients?.some(c => c.id === currentUser?.client?.id && c.migrated_to_halo)

  if (isClientMigratedToHalo) return null

  return (
    <>
      <a className="header-button header-button--add" style={{ cursor: 'pointer' }} onClick={() => setDisplayModal(true)}>new ticket</a>

      {formProps && (
        <Modal showModal={displayModal} removeModal={() => setDisplayModal(false)} title="New ticket">
          <TicketCreateForm {...formProps} />
        </Modal>
      )}
    </>
  )
}

export default TicketCreateModal
